import CMSSiteIdentitySection from './CMSSiteIdentitySection';
import CMSHeroSection from './CMSHeroSection';
import CMSFooterSection from './CMSFooterSection';

export default function CMSLandingTab({
  siteIdentity,
  setSiteIdentity,
  heroForm,
  setHeroForm,
  footerForm,
  setFooterForm,
  isSaving,
  onSaveSiteIdentity,
  onSaveHero,
  onSaveFooter
}) {
  return (
    <div className="space-y-6">
      <CMSSiteIdentitySection
        siteIdentity={siteIdentity}
        setSiteIdentity={setSiteIdentity}
        isSaving={isSaving}
        onSave={onSaveSiteIdentity}
      />

      <CMSHeroSection
        heroForm={heroForm}
        setHeroForm={setHeroForm}
        isSaving={isSaving}
        onSave={onSaveHero}
      />

      <CMSFooterSection
        footerForm={footerForm}
        setFooterForm={setFooterForm}
        isSaving={isSaving}
        onSave={onSaveFooter}
      />
    </div>
  );
}
